import { useState, useCallback, useEffect } from "react";
import api from "../../api";
import { fmtCLP } from "../../utils/formato";
import "../UserManager.css";
import "../InformesCaja.css";

const BASE = "/api/insumos";

const TABS = [
  { id: "fecha", label: "Compras por fecha" },
  { id: "proveedor", label: "Compras por proveedor" },
  { id: "insumo", label: "Compras por insumo" },
  { id: "mes", label: "Gastos por mes" },
  { id: "precios", label: "Historial de precios" },
];

function today() {
  return new Date().toISOString().slice(0, 10);
}

function firstDayMonth() {
  const d = new Date();
  d.setDate(1);
  return d.toISOString().slice(0, 10);
}

export default function ReportesInsumos() {
  const [tab, setTab] = useState("fecha");
  const [desde, setDesde] = useState(firstDayMonth());
  const [hasta, setHasta] = useState(today());
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [insumoIdPrecios, setInsumoIdPrecios] = useState("");
  const [insumos, setInsumos] = useState([]);
  const [data, setData] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  const cargarInsumos = useCallback(() => {
    api.get(`${BASE}/insumos`).then(({ data: d }) => setInsumos(Array.isArray(d) ? d : [])).catch(() => {});
  }, []);

  const aplicar = useCallback(() => {
    setCargando(true);
    setError(null);
    if (tab === "fecha") {
      api.get(`${BASE}/reportes/compras-por-fecha`, { params: { desde, hasta } })
        .then(({ data: d }) => setData(d))
        .catch((e) => setError(e?.response?.data?.error || "Error"))
        .finally(() => setCargando(false));
    } else if (tab === "proveedor") {
      api.get(`${BASE}/reportes/compras-por-proveedor`, { params: { desde, hasta } })
        .then(({ data: d }) => setData(d))
        .catch((e) => setError(e?.response?.data?.error || "Error"))
        .finally(() => setCargando(false));
    } else if (tab === "insumo") {
      api.get(`${BASE}/reportes/compras-por-insumo`, { params: { desde, hasta } })
        .then(({ data: d }) => setData(d))
        .catch((e) => setError(e?.response?.data?.error || "Error"))
        .finally(() => setCargando(false));
    } else if (tab === "mes") {
      api.get(`${BASE}/reportes/gastos-por-mes`, { params: { anio } })
        .then(({ data: d }) => setData(d))
        .catch((e) => setError(e?.response?.data?.error || "Error"))
        .finally(() => setCargando(false));
    } else {
      api.get(`${BASE}/reportes/historial-precios`, { params: insumoIdPrecios ? { insumo_id: insumoIdPrecios } : {} })
        .then(({ data: d }) => setData(d))
        .catch((e) => setError(e?.response?.data?.error || "Error"))
        .finally(() => setCargando(false));
    }
  }, [tab, desde, hasta, anio, insumoIdPrecios]);

  useEffect(() => {
    cargarInsumos();
  }, [cargarInsumos]);

  return (
    <div className="um-wrapper">
      <div className="um-card">
        <div className="um-header">
          <h2>Reportes de insumos</h2>
        </div>
        <div className="inf-tabs" style={{ marginBottom: 16 }}>
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              className={tab === t.id ? "inf-tab active" : "inf-tab"}
              onClick={() => { setTab(t.id); setData(null); setError(null); }}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="um-form" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 8, marginBottom: 16 }}>
          {(tab === "fecha" || tab === "proveedor" || tab === "insumo") && (
            <>
              <div className="um-field">
                <label>Desde</label>
                <input type="date" value={desde} onChange={(e) => setDesde(e.target.value)} />
              </div>
              <div className="um-field">
                <label>Hasta</label>
                <input type="date" value={hasta} onChange={(e) => setHasta(e.target.value)} />
              </div>
            </>
          )}
          {tab === "mes" && (
            <div className="um-field">
              <label>Año</label>
              <input type="number" min="2020" max="2030" value={anio} onChange={(e) => setAnio(Number(e.target.value))} />
            </div>
          )}
          {tab === "precios" && (
            <div className="um-field">
              <label>Insumo (opcional)</label>
              <select value={insumoIdPrecios} onChange={(e) => setInsumoIdPrecios(e.target.value)}>
                <option value="">Todos</option>
                {insumos.map((i) => <option key={i.id} value={i.id}>{i.nombre}</option>)}
              </select>
            </div>
          )}
          <div className="um-actions" style={{ alignSelf: "flex-end" }}>
            <button type="button" className="um-btn um-btn-primary" onClick={aplicar} disabled={cargando}>
              {cargando ? "Cargando…" : "Aplicar"}
            </button>
          </div>
        </div>

        {error && <div className="um-error">Error: {error}</div>}

        {data && Array.isArray(data) && (
          <div className="um-table-wrap">
            {tab === "fecha" && (
              <table className="um-table">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Cant. compras</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((r, i) => (
                    <tr key={i}>
                      <td>{r.fecha}</td>
                      <td>{r.cantidad_compras}</td>
                      <td>{fmtCLP(r.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {tab === "proveedor" && (
              <table className="um-table">
                <thead>
                  <tr>
                    <th>Proveedor</th>
                    <th>Cant. compras</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((r, i) => (
                    <tr key={i}>
                      <td>{r.proveedor_nombre}</td>
                      <td>{r.cantidad_compras}</td>
                      <td>{fmtCLP(r.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {tab === "insumo" && (
              <table className="um-table">
                <thead>
                  <tr>
                    <th>Insumo</th>
                    <th>Categoría</th>
                    <th>Unidad</th>
                    <th>Cant. total</th>
                    <th>Nº compras</th>
                    <th>Total gastado</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((r, i) => (
                    <tr key={i}>
                      <td>{r.insumo_nombre}</td>
                      <td>{r.categoria_nombre || "—"}</td>
                      <td>{r.unidad_medida}</td>
                      <td>{r.cantidad_total}</td>
                      <td>{r.num_compras}</td>
                      <td>{fmtCLP(r.total_gastado)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {tab === "mes" && (
              <table className="um-table">
                <thead>
                  <tr>
                    <th>Mes</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((r, i) => (
                    <tr key={i}>
                      <td>{r.mes}</td>
                      <td>{fmtCLP(r.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {tab === "precios" && (
              <table className="um-table">
                <thead>
                  <tr>
                    <th>Insumo</th>
                    <th>Fecha compra</th>
                    <th>Precio unit.</th>
                    <th>Cantidad</th>
                    <th>Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((r, i) => (
                    <tr key={i}>
                      <td>{r.insumo_nombre}</td>
                      <td>{r.fecha_compra}</td>
                      <td>{fmtCLP(r.precio_unitario)}</td>
                      <td>{r.cantidad}</td>
                      <td>{fmtCLP(r.subtotal)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
